document.addEventListener('DOMContentLoaded', function() {
  const faqQuestions = document.querySelectorAll('.pm-8153-faq-question');

  // Open the first FAQ by default
  if (faqQuestions.length > 0) {
    const firstQuestion = faqQuestions[0];
    const firstAnswer = firstQuestion.nextElementSibling;

    firstQuestion.setAttribute('aria-expanded', 'true');
    firstAnswer.classList.add('active');
  }

  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const isExpanded = question.getAttribute('aria-expanded') === 'true';

      // Toggle the clicked answer
      if (isExpanded) {
        question.setAttribute('aria-expanded', 'false');
        answer.classList.remove('active');
      } else {
        question.setAttribute('aria-expanded', 'true');
        answer.classList.add('active');
      }
    });
  });
});